App.factory('zochaWorkersService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ZochaWorkersService() {
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/zocha/user/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.register = function(data) {
            return baseService.post(Config.API_URL + '/zocha/user/register', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.findByIdentifier = function (pesel) {
            var json = angular.toJson({
                "identifier": pesel,
            });

            return baseService.post(Config.API_URL + '/zocha/user/findByIdentifier', json);
        };

        this.getWorkerById = function(id) {
            return baseService.post(Config.API_URL + '/zocha/user/'+id+'/details', {}).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

    }
    return new ZochaWorkersService();
}]);